module.exports = __webpack_public_path__ + "img/menu.bad22f75.svg";